import React, { useContext, useMemo } from "react";

import { SettingsPanel } from "./SettingsPanel";
import { GrigoraEditorContext } from "../context";
import { AnimatePresence, motion } from "framer-motion";
import Draggable from "react-draggable";
import { Rnd } from "react-rnd";
import { CREATE_BEZIER_TRANSITION } from "../../utils";

const GrigoraRightBar = ({ isJoyrideOpen }) => {
  const { isBlockSettingsVisible } = useContext(GrigoraEditorContext);

  const [size, setSize] = React.useState({
    width: 300,
    height: 500,
    x: window.innerWidth - 300 - 50,
    y: 50,
  });

  const dragHandlers = useMemo(() => {
    return {
      onDragStart: (e) => {
        // Set pointer events to auto
        document
          .querySelector(".helper-container")
          ?.style?.setProperty("pointer-events", "auto", "important");
      },
      onDragStop: (e, d) => {
        // Set pointer events to none
        setSize({ ...size, x: d.x, y: d.y });
        document
          .querySelector(".helper-container")
          ?.style?.setProperty("pointer-events", "none", "important");
      },
      size: { width: size.width, height: size.height },
      position: { x: size.x, y: size.y },
      onResizeStart: () => {
        document
          .querySelector(".helper-container")
          ?.style?.setProperty("pointer-events", "auto", "important");
      },
      onResizeStop: (e, direction, ref, delta, position) => {
        document
          .querySelector(".helper-container")
          ?.style?.setProperty("pointer-events", "none", "important");

        setSize({
          width: ref.style.width,
          height: ref.style.height,
          ...position,
        });
      },
      style: {
        display: "flex",
        zIndex: 1000,
        // flex: 1,
      },
      minWidth: 220,
      minHeight: 300,
      bounds: ".page-container",
    };
  }, [size.width, size.height, size.x, size.y]);

  return (
    <>
      {/* {isBlockSettingsVisible && (
        <Rnd dragHandleClassName="block-settings__header" {...dragHandlers}>
          <SettingsPanel isJoyrideOpen={isJoyrideOpen} />
        </Rnd>
      )} */}

      <AnimatePresence>
        {isBlockSettingsVisible && (
          <motion.div
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, width: "24%", overflow: "unset" },
              collapsed: {
                opacity: 0,
                width: 0,
                paddingRight: 0,
                paddingLeft: 0,
                overflow: "hidden",
              },
            }}
            transition={CREATE_BEZIER_TRANSITION()}
            className="w-[24%] max-w-[300px]"
            {...dragHandlers}
          >
            <SettingsPanel isJoyrideOpen={isJoyrideOpen} />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default GrigoraRightBar;
